export const columns = [
  {
    title: "操作人",
    width: 120,
    dataIndex: "operatorName",
    key: "operatorName"
  },
  {
    title: "业务单号",
    dataIndex: "bizOrderNo",
    key: "bizOrderNo",
    width: 220,
  },
  {
    title: "批次包",
    dataIndex: "pkgCode",
    width: 180,
    key: "pkgCode"
  },
  {
    title: "系统单号",
    dataIndex: "systemOrderNo",
    width: 220,
    key: "systemOrderNo"
  },
  {
    title: "操作节点",
    dataIndex: "nodeName",
    width: 130,
    key: "nodeName"
  },
  {
    title: "操作数量",
    dataIndex: "operateNums",
    key: "operateNums",
    width: 120,
    customRender: (text, record, index) => {
      return text < 1 ? 0 : text
    },
  },
  {
    title: "操作时间",
    dataIndex: "operateTime",
    width: 180,
    key: "operateTime"
  },
  {
    title: "操作内容",
    dataIndex: "operatorContent",
    key: "operatorContent"
  },
];